import React from 'react';
import PropTypes from 'prop-types';

import { Map, MapMarker } from '/components/map/components';

const ProducerMap = ({ latitude, longitude }) => (
    <Map
        defaultCenter={{
            lat: latitude,
            lng: longitude,
        }}
        defaultZoom={12}
    >
        <MapMarker
            title=""
            href={`https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`}
            lat={latitude}
            lng={longitude}
            theme="red"
        />
    </Map>
);

export { ProducerMap };
